import apiServices from "@/services/yungol-services";
import { parseCompaniesBlock, parseHeader } from "./helpers";

export const fetchCompaniesBlock = async (year, params) => {
  const response = await apiServices.get(
    `/empresas1${year ? "/" + year : ""}`,
    { params },
  );

  if (response.status !== 200) {
    throw new Error("Error fetching companies");
  }

  return parseCompaniesBlock(response.data);
};

export const fetchCompaniesHeader = async (year) => {
  const response = await apiServices.get(
    `/empresasheader${year ? "/" + year : ""}`,
  );

  if (response.status !== 200) {
    throw new Error("Error fetching companies header");
  }

  return parseHeader(response.data);
};

export const selectCompanyRequest = async (id) => {
  const change = await apiServices.get(`/changecompany/${id}`);
  if (!change.data) throw new Error("Error changing company");
  const credential = await apiServices.get("/empresacredential");
  if (!credential.data) throw new Error("Error fetching company credential");
  return credential.data;
};

export const deleteCompanyRequest = async (id) => {
  const response = await apiServices.delete(`/empresa/${id}`);

  return response.data;
};



// WEBPACK FOOTER //
// ./src/components/empresas/api.js